import * as React from "react";
import { IconButton } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import { useIntl } from "@grandvisionhq/state";
import { useSetLoyaltyDetails } from "../../../../hooks/hooks/use-set-loyalty-details.js";
import "uuid";
import "@grandvisionhq/graphql";
import "@grandvisionhq/lib-utils-w3c";
/* empty css                              */
const LoyaltyPointsCardDetails = ({
  cardNumber,
  cartId = null,
  withClearAction = true
}) => {
  const { getLabel } = useIntl();
  const labels = {
    savedCardText: getLabel("cart.loyalty.saved.number")
  };
  const { setLoyaltyCardNumber, isUpdating } = useSetLoyaltyDetails();
  const clearCardDetails = React.useCallback(
    (inputValue) => {
      setLoyaltyCardNumber(inputValue, cartId, null);
    },
    [setLoyaltyCardNumber, cartId]
  );
  return /* @__PURE__ */ React.createElement("div", { className: "loyalty-card-details__container" }, /* @__PURE__ */ React.createElement(Text, { className: "loyalty-card-details__text" }, labels.savedCardText, ": ", cardNumber), withClearAction && /* @__PURE__ */ React.createElement(
    IconButton,
    {
      onClick: () => clearCardDetails(null),
      "data-t": "remove-loyalty-point-card",
      className: "loyalty-card-details__delete",
      "aria-label": getLabel("common.actions.delete"),
      disabled: isUpdating
    },
    /* @__PURE__ */ React.createElement(Icon, { className: "loyalty-card-details__delete-icon", height: 16, width: 16, name: "clear" })
  ));
};
export {
  LoyaltyPointsCardDetails
};
//# sourceMappingURL=LoyaltyPointsCardDetails.js.map
